/**
 * Zero-dependency leaf module.
 *
 * PERF: this used to live in `useEventTrackers.ts`. `PageViewPixel` is statically
 * imported by `app/[lang]/layout.tsx`, so importing one helper from there dragged
 * the whole analytics/pixel dependency graph into the initial bundle of EVERY route.
 * (At the time that graph also pulled in `react-gtm-module`, since removed.)
 *
 * Keep this file free of imports so it stays a leaf.
 */
export function getFirstAndLastName(fullName: string): {
  firstName: string;
  lastName: string;
} {
  if (!fullName || typeof fullName !== "string") {
    return { firstName: "", lastName: "" };
  }

  // Trim and clean up the name (remove extra spaces)
  const cleanedName = fullName.trim().replace(/\s+/g, " ");
  const nameParts = cleanedName.split(" ");

  // Handle empty string case
  if (nameParts.length === 0) {
    return { firstName: "", lastName: "" };
  }

  // If only one name part, it's both first and last
  if (nameParts.length === 1) {
    return { firstName: nameParts[0], lastName: nameParts[0] };
  }

  // For multiple parts, first is first part, last is last part
  const firstName = nameParts[0];
  const lastName = nameParts[nameParts.length - 1];

  return { firstName, lastName };
}
